module.exports = __webpack_public_path__ + "static/media/seal concept.ec6572bb.png";